import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flyer-page print-friendly" }
const _hoisted_2 = { class: "flyer-container" }
const _hoisted_3 = { class: "info-section" }
const _hoisted_4 = { class: "qr-section" }
const _hoisted_5 = { class: "qr-box" }

import { onMounted, ref } from 'vue'
import QRCode from 'qrcode'


export default /*@__PURE__*/_defineComponent({
  __name: 'FlyerGeneralInfoView',
  setup(__props) {

const qrCodeCanvas = ref<HTMLCanvasElement | null>(null)

onMounted(async () => {
  if (qrCodeCanvas.value) {
    try {
      await QRCode.toCanvas(qrCodeCanvas.value, 'https://spacecoaststem.org/request', {
        width: 200,
        margin: 1,
        color: {
          dark: '#2c4a6b',
          light: '#ffffff'
        }
      })
    } catch (error) {
      console.error('Error generating QR code:', error)
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"header-section\" data-v-1e686aa9><div class=\"logo-section\" data-v-1e686aa9><img src=\"/assets/img/logo.png\" alt=\"Space Coast STEM Logo\" class=\"logo\" data-v-1e686aa9></div><div class=\"tagline\" data-v-1e686aa9><h1 data-v-1e686aa9>Empowering Students Through Technology</h1><p class=\"subtitle\" data-v-1e686aa9>Free Laptops for Brevard County Students</p></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mission-box" }, [
          _createElementVNode("h2", null, "Our Mission"),
          _createElementVNode("p", null, [
            _createTextVNode(" Space Coast STEM provides "),
            _createElementVNode("strong", null, "free refurbished laptops"),
            _createTextVNode(" to students in Brevard County who lack access to technology at home. We believe every student deserves the tools they need to succeed in today's digital world. ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("canvas", {
              ref_key: "qrCodeCanvas",
              ref: qrCodeCanvas,
              class: "qr-canvas"
            }, null, 512),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "qr-text" }, [
              _createElementVNode("h3", null, "Request a Laptop"),
              _createElementVNode("p", null, "Scan to fill out our simple request form"),
              _createElementVNode("p", { class: "url" }, "spacecoaststem.org/request")
            ], -1))
          ])
        ])
      ]),
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"teacher-section\" data-v-1e686aa9><div class=\"teacher-box\" data-v-1e686aa9><h2 data-v-1e686aa9>Teachers: Help Connect Students in Need</h2><p data-v-1e686aa9> As an educator, you can help identify students would benefit from this program and help get them the tools they need. Use the teacher portal to approve requests and claim equipment for your students. </p><div class=\"signup-info\" data-v-1e686aa9><div class=\"signup-icon\" data-v-1e686aa9>👨‍🏫</div><div class=\"signup-details\" data-v-1e686aa9><h3 data-v-1e686aa9>Teacher Portal Signup</h3><p class=\"signup-url\" data-v-1e686aa9><strong data-v-1e686aa9>portal.spacecoaststem.org/signup</strong></p><p class=\"signup-description\" data-v-1e686aa9>Create an account to submit and track student laptop requests</p></div></div></div></div>", 1))
    ])
  ]))
}
}

})